import { Link } from "react-router-dom";
import { getTeams } from "../api";
import { routes } from "../routes";
import { useAsync } from "../useAsync";
import { Markdown, Pane } from "../ui";
import { ApplicationQuestions } from "./Apply";

/**
 * The application form as an applicant sees it, on its own URL (2026-10-13).
 *
 * 🔴 THE APPLICANT'S OWN RENDERER (`ApplicationQuestions`), against the questions as SAVED —
 * the Teams preview's rule, for the same reason: a preview drawn with other controls makes a
 * claim about itself that is the one thing it gets wrong.
 * ⚠️ NOTHING HERE REACHES `/api/apply`. The questions come from the teacher's own payload, so
 * no route outside that router resolves an applicant.
 */
export function ApplicantFormPreviewPage({ courseId }: { courseId: string }) {
  const q = useAsync(() => getTeams(courseId), [courseId]);
  return (
    <div className="apply-pad stack">
      <p className="alert info" role="status">
        Preview. This is the form applicants are shown, drawn with their own controls. Nothing
        typed here is saved; the questions are edited on the
        {" "}<Link to={routes.applicants(courseId, "questions")}>Questions tab</Link>.
      </p>
      <Pane q={q}>
        {(d) => (
          <>
            <section className="apply-hero">
              <div className="apply-eyebrow"><span className="kick">Application</span></div>
              <h2>{d.course.name}</h2>
              {d.form.intro && <div className="apply-intro"><Markdown text={d.form.intro} /></div>}
            </section>
            {/* ⚠️ INSIDE `.stack`: `.solo` caps that at a reading width, and a bare form ran the
                width of the monitor (seen in a render). */}
            <div className="apply-body solo">
              <div className="stack">
                <ApplicationQuestions questions={d.questions} draft={{}} set={() => {}}
                                      locked={() => true} note="" />
              </div>
            </div>
          </>)}
      </Pane>
      <p className="small muted">
        <Link to={routes.applicants(courseId, "questions")}>← Back to the questions</Link>
      </p>
    </div>
  );
}
